import { Group, Image, Stack, Text, Title, UnstyledButton } from '@mantine/core'
import { TwContainer } from '@/lib/components/TwContainer'
import { ContactForm } from '@/components/ContactForm'
import { Locations } from '@/components/Locations'

export const ContactUs = ({
	title,
	subtitle,
	heading,
	noLocations,
}: {
	title?: string
	subtitle?: string
	heading?: string
	noLocations?: boolean
}) => {
	return (
		<>
			<section className={'bg-secondary'} id={'contact'}>
				<TwContainer md className={'justify-center py-28 gap-4'} column>
					{heading !== '' && (
						<Title ta={'center'} variant={'cyan'} fz={18}>
							{heading || 'CONTACT US TODAY'}
						</Title>
					)}
					<Title variant={'title'}>{title || 'Member of Wellview Care'}</Title>
					{subtitle && (
						<Text variant={'gray'} className={'max-w-3xl mx-auto'}>
							{subtitle}
						</Text>
					)}
					<Group align={'center'} justify={'center'} gap={40} mt={'xl'}>
						<ContactForm className={'max-w-xl'} />
						<Stack maw={320} gap={40}>
							<Text>We aim to provide and assist in creating the best memories for our customers</Text>
							<UnstyledButton className={'flex gap-4 flex-row items-center flex-wrap justify-start'} component={'a'} href={'tel:+1 844-650-2626'}>
								<Image loading={'lazy'} alt={'Call Us'} w={44} h={44} src={'/images/telephone.svg'} />
								<Stack gap={0}>
									<Text fw={400} tt={'uppercase'}>
										Call Us
									</Text>
									<Title fz={18} fw={700} fs={'lg'}>
										844-650-2626
									</Title>
								</Stack>
							</UnstyledButton>
							<UnstyledButton className={'flex gap-4 flex-row items-center flex-wrap justify-start'} component={'a'} href={'fax:+1 844-647-0990'}>
								<Image loading={'lazy'} w={44} h={44} alt={'Fax Us'} src={'/images/fax.svg'} />
								<Stack gap={0}>
									<Text fw={400} tt={'uppercase'}>
										Fax Us
									</Text>
									<Title fz={18} fw={700} fs={'lg'}>
										844-647-0990
									</Title>
								</Stack>
							</UnstyledButton>
							<UnstyledButton
								className={'flex gap-4 flex-row items-center flex-wrap justify-start'}
								component={'a'}
								href={'mailto:office@wellviewcare.org'}
							>
								<Image loading={'lazy'} alt={'Email Us'} w={44} h={44} src={'/images/email.svg'} />
								<Stack gap={0}>
									<Text fw={400} tt={'uppercase'}>
										Email Us
									</Text>
									<Title fz={18} fw={700} fs={'lg'}>
										office@wellviewcare.org
									</Title>
								</Stack>
							</UnstyledButton>
						</Stack>
					</Group>
				</TwContainer>
			</section>
			{!noLocations && <Locations />}
		</>
	)
}
